import { Language } from './util/lang';
import { Component, OnInit } from '@angular/core';
import { getUserId, detectUser } from './util/user';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  ngOnInit(): void {
    detectUser();
  }

  public getLangFromUrl(): void {
    const pathName = window.location.pathname;
    let lang;
    switch (pathName.substr(0, 3)) {
      case '/en':
        lang = 'en';
        break;
      case '/ru':
        lang = 'ru';
        break;
      default:
        lang = 'hy';
        break;
    }
    Language.setCurrentLang(lang, false);
  }

  title = 'PaymentServiceWeb';
  constructor(translate: TranslateService) {
    this.getLangFromUrl();
    translate.setDefaultLang(Language.getCurrentLang());
  }
}
